import { createAsyncThunk } from '@reduxjs/toolkit';

import {
  fetchOptionalFieldsExternal,
  getDraftById as getExternalDraftById,
} from '../../ExternalUserFlow/Services/Draft';
import { fetchRequestApprovals } from '../../Services/Approval';
import { authApi } from '../../Services/authApi';
import {
  fetchGetFields,
  getDraftById,
  getS3ReferencePresignedURL,
} from '../../Services/Draft';
import { fetchStamps } from '../../Services/Stamp';

export const fetchFields = createAsyncThunk(
  'complete-draft/fetchFields',
  async (id: string) =>
    await authApi(`data-dictionary/get_field?contract_type=${id}`)
);

export const fetchCompleteDraftFields = createAsyncThunk(
  'complete-draft/fetchOptionalFields',
  async ({
    id,
    contract_id,
    contract_type_id,
    category_id,
    isExternal,
  }: {
    id: string;
    contract_id?: string;
    contract_type_id?: string;
    category_id?: string;
    isExternal?: boolean;
  }) => {
    const response: any = isExternal
      ? await fetchOptionalFieldsExternal(id)
      : await authApi(`stylus/draft/optional_field/${id}/`);
    if (!response.results.length && !isExternal && contract_id) {
      const fieldResponse: any = await fetchGetFields(contract_id);
      if (fieldResponse?.data.length && contract_type_id) {
        let params = `?approval_type=contract_condition&contract=${contract_type_id}&clause_type=merge_tag`;
        if (category_id) {
          params = `${params}&contract_category=${category_id}`;
        }
        const approvalResponse = await fetchRequestApprovals(params).then(
          (data) => data.results
        );
        return {
          optionalFields: false,
          data: fieldResponse.data,
          approvalData: approvalResponse,
        };
      } else {
        return {
          optionalFields: false,
          data: fieldResponse.results,
        };
      }
    } else {
      return {
        optionalFields: true,
        data: isExternal ? response.results : response.results,
      };
    }
  }
);

export const getAccessUrl = createAsyncThunk(
  'view-draft/accessUrl',
  async (payload: any) => {
    const response: any = getS3ReferencePresignedURL({ body: payload });
    return response?.response?.presigned_url;
  }
);

export const fetchReminderById = createAsyncThunk(
  'reminders/fetchById',
  async (id: string) => await authApi.get(`reminder/${id}/`)
);

export const fetchDraftById = createAsyncThunk(
  'draft/fetchById',
  async ({ id, isExternal = false }: { id: string; isExternal?: boolean }) => {
    const response = isExternal
      ? await getExternalDraftById(id)
      : await getDraftById(id);
    return response;
  }
);

export const fetchDraftStamps = createAsyncThunk(
  'draft/fetchDraftStamp',
  async (params: string) => await fetchStamps(params)
);
